import * as environment from '@app/environment'

export const isUrlInternal = (url: string): boolean => {
  return url.startsWith(environment.apiHost) || url.startsWith(environment.apiTrackHost)
}
